import { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import RouterPrompt from "react-router-prompt";
import ConfirmationPrompt from "../components/controls/ConfirmationPrompt";
import PubSub from "../services/PubSub";
import Spinner from "../components/controls/Spinner";
import InfoModal from "../components/controls/InfoModal";
import DeploymentInfoToast from "../routes/deployment/deploymentManagement/DeploymentInfoToast";

const RouterLayout = () => {
    const { id } = useParams();
    const [translate] = useTranslation();
    const [confirmedNavigation, setConfirmedNavigation] = useState(0);

    useEffect(() => {
        const timerInterval = 5000;
        const subscriptionId = PubSub.subscribe("timer-start", (deploymentId, callbackFunction) => {
            if (!window.deployTimer) {
                window.deployTimer = {};
            }

            clearInterval(window.deployTimer[deploymentId]);
            window.deployTimer[deploymentId] = setInterval(async () => {
                callbackFunction(deploymentId);
            }, timerInterval);
        });

        const stopSubscriptionId = PubSub.subscribe("timer-stop", (deploymentId, onStop) => {
            if (window.deployTimer[deploymentId]) {
                clearInterval(window.deployTimer[deploymentId]);
                onStop?.();
            }
        });
        return () => {
            PubSub.unsubscribe("timer-start", subscriptionId);
            PubSub.unsubscribe("timer-stop", stopSubscriptionId);
        }
    }, []);

    useEffect(() => {
        const unsavedChangesSubId = PubSub.subscribe("has-unsaved-changes", () => {
            setConfirmedNavigation((prev) => prev + 1);
            PubSub.publish("deployment-unlock-timer-refresh", { deploymentId: id })
        });
        const nounsavedChangesSubId = PubSub.subscribe("no-unsaved-changes", () => {
            setConfirmedNavigation((prev) => prev === 0 ? 0 : prev - 1);
        });

        return () => {
            PubSub.unsubscribe("has-unsaved-changes", unsavedChangesSubId);
            PubSub.unsubscribe("no-unsaved-changes", nounsavedChangesSubId);
        };
    }, [id]);

    return <>
        <Spinner />
        <InfoModal />
        <DeploymentInfoToast />

        <RouterPrompt when={confirmedNavigation > 0}>
            {({ isActive, onConfirm, onCancel }) => (
                <ConfirmationPrompt
                    show={isActive}
                    message={translate("OTM_UNSAVED_CHANGES")}
                    onConfirm={() => {
                        onConfirm();
                        setTimeout(() => setConfirmedNavigation(0), 100);
                    }}
                    onCancel={onCancel}
                />
            )}
        </RouterPrompt>

        <Outlet /> {/* This is where routes now get inserted into: handled in routerConfig.js  */}
    </>
}

export default RouterLayout;


